export default __webpack_public_path__ + "img/Zipcode.08d98c96.svg";